import store from "../store/index";
import Echo from "laravel-echo";
import Pusher from "pusher-js";
import JwtService from "./jwt.service";

const EchoService = {
  init() {
    window.Pusher = Pusher;

    // Pusher.log = (message) => {
    //   if (window.console && window.console.log) {
    //     window.console.log(message);
    //   }
    // };

    window.Echo = new Echo({
      broadcaster: "pusher",
      key: process.env.VUE_APP_PUSHER_APP_KEY,
      cluster: "mt1",
      encrypted: true,
      authEndpoint: process.env.VUE_APP_PUSHER_PUSHER_URL,
      auth: {
        headers: {
          Authorization: `Bearer ${JwtService.getToken()}`,
        },
      },
    });

    window.Echo.connector.pusher.connection.bind("connected", () => {
      //   store.commit('updatePusherStatus', 'connected')
    });
    window.Echo.connector.pusher.connection.bind("disconnected", () => {
      //   store.commit('updatePusherStatus', 'disconnected')
    });

    window.Echo.channel(`private-App.Models.User.${store.state.auth.user.id}`).listen(
      "NotifyUserOnPrivateChannel",
      (e) => {
        console.log(e);
      }
    );
    // .error((error) => {
    //   store.commit('updatePusherStatus', error.type)
    // })
  },
};

export default EchoService;
